<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>



// WEBPACK FOOTER //
// App.vue?373a3466